import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { routes } from './app.routes';
import { AppConfigService } from './core/services/app-config.service';
import { AppInitializerService } from './core/services/app-intializer.service';
import { TranslateLoaderService } from './core/services/translate-loader.service';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { TokenInterceptor } from './core/interceptors/token.interceptors';
import { ErrorInterceptor } from './core/interceptors/error.interceptors';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DatePipe } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      MatChipsModule,
      NgxSkeletonLoaderModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateLoaderService,
          deps: [HttpClient],
        }
      }),
      NgxDaterangepickerMd.forRoot({
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        clearLabel: 'Clear',
        locale: {
          format: 'YYYY-MM-DD',
          displayFormat: 'YYYY-MM-DD',
          direction: 'ltr',
          firstDay: 1,
          monthNames: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ],
          daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
        }
      })
    ),
    AppInitializerService,
    AppConfigService,
    DatePipe,
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializerService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(), provideAnimationsAsync(),
  ]
};




export function initializeApp(appInitializerService: AppInitializerService) {
  return () => appInitializerService.initializeApp();
}
